import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { TransformedFiles } from '@core/models/designTool';
import { MdbModalRef } from 'mdb-angular-ui-kit/modal';
import { ProductDesignLibraryComponent } from '../product-design-library.component';
import { analyzeImage } from '@shared/utilities/file.utils';
import { selectDesignFilesTransformed } from '@core/state/design-tool/design-tool.selectors';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { removeFileFromDesignLibrary } from '@core/state/design-tool/design-tool.actions';

@Component({
  selector: 'app-product-design-library-modal',
  templateUrl: './product-design-library-modal.component.html',
  styleUrls: ['./product-design-library-modal.component.scss']
})
export class ProductDesignLibraryModalComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  designFiles: TransformedFiles[] = []
  openUploadArtModal: (data: any) => void;
  handleImageClick: (data: TransformedFiles[]) => void;
  
  constructor(
    public modalRef: MdbModalRef<ProductDesignLibraryModalComponent>,
    private store: Store
  ) {}

  ngOnDestroy(): void {
    this.destroy$.next(null)
  }

  ngOnInit(): void {
    this.store.select(selectDesignFilesTransformed).pipe(takeUntil(this.destroy$)).subscribe(files => {
      this.designFiles = files.map(e => analyzeImage(e))
    })
  }

  close(data?: TransformedFiles[]): void {
    this.modalRef.close(data)
  }

  onRemoveImage(fileName: string) {
    this.store.dispatch(removeFileFromDesignLibrary({fileName}))
  }
}
